
export const EPeriodType = {
  date: 1,
  month: 2,
  year: 3,
}
